<template>
  <div>
    <v-tooltip :disabled="!isTempNumber" bottom>
      <template #activator="{on}">
        <span :class="{ 'temp-number': isTempNumber }" v-on="on">
          {{ !!number ? number : !!tempNumber ? tempNumber : $t("components.documentNumber.notSet") }}
        </span>
      </template>
      {{ contextTooltipText }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "DocumentNumber",
  props: {
    number: {
      required: true
    },
    tempNumber: {
      required: false,
      default: null
    },
    tooltipText: {
      required: false,
      default: false
    }
  },
  computed: {
    isTempNumber() {
      return !this.number && !!this.tempNumber;
    },
    contextTooltipText() {
      if (this.tooltipText === false) {
        return this.$t("components.documentNumber.tooltip");
      }
      return this.tooltipText;
    }
  }
};
</script>

<style scoped>
.temp-number {
  font-style: italic;
}
</style>
